<div class="view-dialog-container" *ngIf="form">
    <div class="header-container">
        <div class="header-title">New Email</div>
        <div class="cros-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon" />
        </div>
    </div>

    <form [formGroup]="form" class="d-grid">
        <div class="profile-scroll d-grid gap-14">
            <div class="form-group">
                <app-input context="Normal" class="form-item" label="From" placeholder="Enter your email" type="text"
                    [disabled]="true" [control]="form.get('fromEmail')" [required]="true"
                    [customErrorMessages]="customErrorMessages.fromEmail">
                </app-input>
            </div>

            <div class="form-group">
                <app-multi-select [label]="'To'" placeholder="Select recipient email" [options]="recipientEmailOptions"
                    [required]="true" [errorMessage]="customErrorMessages.toEmail.required" formControlName="toEmail"
                    (selectionChange)="onRecipientsChange($event)">
                </app-multi-select>
            </div>

            <div class="form-group">
                <app-input context="Normal" class="form-item" label="cc" placeholder="Enter cc email" type="email"
                    [control]="form.get('ccEmail')" [customErrorMessages]="customErrorMessages.ccEmail">
                </app-input>
            </div>

            <div class="form-group">
                <app-input context="Normal" class="form-item" label="Subject" placeholder="Enter subject" type="text"
                    [required]="true" [control]="form.get('subject')"
                    [customErrorMessages]="customErrorMessages.subject">
                </app-input>
            </div>

            <!-- Text Editor Section -->
            <div class="form-group">
                <label class="editor-label">Compose mail <span class="req-star">*</span></label>
                <div class="text-editor-container">
                    <div class="editor-toolbar">
                        <button type="button" class="toolbar-btn" (click)="formatText('bold')" title="Bold">
                            <strong>B</strong>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="formatText('italic')" title="Italic">
                            <em>I</em>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="formatText('underline')" title="Underline">
                            <u>U</u>
                        </button>
                        <button type="button" class="toolbar-btn" (click)="formatText('insertUnorderedList')"
                            title="Bullet List">
                            • List
                        </button>
                        <button type="button" class="toolbar-btn" (click)="formatText('insertOrderedList')"
                            title="Numbered List">
                            1. List
                        </button>
                    </div>
                    <div class="editor-content" contenteditable="true" (input)="onEditorInput($event)"
                        (blur)="onEditorBlur()" placeholder="Compose your email..." #emailEditor>
                    </div>
                </div>
                <div *ngIf="form.get('composeMail')?.invalid && form.get('composeMail')?.touched" class="error-message">
                    {{ customErrorMessages.composeMail.required }}
                </div>
            </div>
        </div>

        <div class="d-flex gap-4 justify-content-center" style="padding: 1rem;">
            <button type="button" class="cancel-button" (click)="onCancel()">
                Cancel
            </button>
            <button type="button" class="update-button" [disabled]="loading" (click)="onSave()">
                {{ loading ? 'Sending...' : 'Send' }}
            </button>
        </div>
    </form>
</div>